const embeds = Array.from(document.querySelectorAll('[data-video-embed]'));

export function init() {
	embeds.forEach(element => {
		element.addEventListener('click', onClick, true);
	});
}

function onClick(event) {
	const embedCode = event.currentTarget.dataset.videoEmbed;

	if (embedCode) {
		event.currentTarget.innerHTML = embedCode;
		event.currentTarget.removeEventListener('click', onClick);
	}
}
